import React from 'react';
import { Card, Stack, Title, Button } from '@mantine/core';
import { BookingDispute } from '../../../../../components/modals/BookingDispute';
import { BookingResponseModel } from '../../../../../types/BookingModels';
import { primaryColor } from '../../../../../constants/theme';

interface SingleBookingFeedbackCardProps {
  booking: BookingResponseModel;
  disputeOpened: boolean;
  setDisputeOpened: (opened: boolean) => void;
}

export const SingleBookingFeedbackCard = ({
  booking,
  disputeOpened,
  setDisputeOpened,
}: SingleBookingFeedbackCardProps) => {
  return (
    <Card maw={600} mx='auto' shadow='none' withBorder data-testid="single-booking-feedback-card">
      <Stack>
        <Title order={5}>Feedback</Title>
        <Button
          radius='md'
          onClick={() => setDisputeOpened(true)}
          variant='outline'
          color={primaryColor}
          data-testid="dispute-button"
        >
          Not what you expected?
        </Button>
        <BookingDispute
          bookingId={booking.id}
          professionalId={booking.professionalId}
          onClose={() => setDisputeOpened(false)}
          open={disputeOpened}
        />
      </Stack>
    </Card>
  );
};
